/** Maximum overtime bar capacity (normalized; UI maps 0 … this → 0 … 100%). */
export const BOGGLE_OVERTIME_START_VALUE = 3.0
/** Drain accelerates while in overtime (bar units per second²). Lower = longer overtime. */
export const BOGGLE_OVERTIME_ACCELERATION_PER_SECOND = 2.5
export const BOGGLE_OVERTIME_LETTER_PRESS_PAUSE_MS = 200
export const BOGGLE_OVERTIME_BACKSPACE_FREE_PRESSES = 1
export const BOGGLE_OVERTIME_BACKSPACE_ESCALATION_EXPONENT = 3
export const BOGGLE_OVERTIME_BACKSPACE_PENALTY_PER_TIER = 0.04
export const BOGGLE_OVERTIME_BACKSPACE_VELOCITY_PER_TIER = 0.08
